"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderContext = void 0;
var tslib_1 = require("tslib");
/**
 * 对应表头的一格
 */
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../utils");
var SortIcon_1 = tslib_1.__importDefault(require("./SortIcon"));
var FilterIcon_1 = tslib_1.__importDefault(require("./filter/FilterIcon"));
var hooks_1 = require("./hooks");
function Header(props) {
    var column = props.column;
    var tablePrefix = hooks_1.useTable().prefix;
    var _a = react_1.useState(null), elm = _a[0], setElm = _a[1];
    var headerPrefix = utils_1.concat(tablePrefix, 'header');
    var thPrefix = utils_1.concat(headerPrefix, 'th');
    var headerProps = column.getHeaderProps({ className: thPrefix, style: { width: column.width } });
    var sortOptions = column.meta.sort;
    var filterOptions = column.meta.filter;
    var title = column.meta.title;
    var sortIconView = sortOptions != null && (react_1.default.createElement(SortIcon_1.default, { prefix: headerPrefix, order: sortOptions.order, onSort: sortOptions.onChange }));
    var filterIconView = filterOptions != null && (react_1.default.createElement(FilterIcon_1.default, { column: column }));
    return (react_1.default.createElement(exports.HeaderContext.Provider, { value: { headerElement: elm, headerPrefix: headerPrefix } },
        react_1.default.createElement("th", tslib_1.__assign({}, headerProps, { ref: setElm, title: undefined }),
            title,
            sortIconView,
            filterIconView)));
}
exports.default = Header;
exports.HeaderContext = react_1.createContext({
    headerElement: null,
    headerPrefix: ''
});
//# sourceMappingURL=Header.js.map